import Text from './components/Text';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'text',
  pluginComponent: Text,
});
